import {
  CatalogData,
  Service,
  ServiceType,
  OfferedAsType,
  PaymentType,
  TimezoneType,
  ServiceLocationType,
} from '@wix/bookings-uou-types';

export function createDummyCatalogData(): CatalogData {
  const service: Service = {
    id: 'some-id',
    info: {
      name: 'Some Service',
      tagline: 'Some Tag Line',
      type: ServiceType.INDIVIDUAL,
    },
    locations: [
      {
        type: ServiceLocationType.OWNER_BUSINESS,
        businessLocation: {
          id: 'location-1-id',
        },
      },
      {
        type: ServiceLocationType.OWNER_BUSINESS,
        businessLocation: {
          id: 'location-2-id',
        },
      },
    ],
    staffMembers: [
      {
        id: 'staff-1-id',
        name: 'Staff 1',
      },
      {
        id: 'staff-2-id',
        name: 'Staff 2',
      },
    ],
    policy: {
      uouHidden: false,
      isBookOnlineAllowed: true,
      isPendingApprovalFlow: false,
      maxParticipantsPerBook: 1,
      capacity: 1,
      minutesBeforeSlotBookWindowStart: 0,
      minutesBeforeSlotBookWindowEnd: 0,
    },
    payment: {
      offeredAs: [OfferedAsType.ONE_TIME],
      paymentDetails: {
        currency: '$',
        price: 1,
        priceText: '',
        minCharge: 0,
        isFree: false,
        paymentType: PaymentType.ONLINE,
        displayTextForPlan: '',
      },
    },
  };

  return {
    services: [service],
    businessInfo: {
      language: 'en',
      currency: '$',
      timeZone: 'America/New_York',
      timezoneProperties: {
        defaultTimezone: TimezoneType.BUSINESS,
        clientCanChooseTimezone: true,
      },
      regionalSettingsLocale: 'en-US',
    },
    activeFeatures: {
      applicableForCourse: true,
      bookingsStaffLimit: 1,
      applicableForServiceList: true,
      applicableForGroups: true,
      applicableForIndividual: true,
      applicableForPayments: true,
      applicableForReminders: true,
      applicableForSmsReminders: true,
    },
  };
}
